import { api } from "@/builders/axios";
import { CareerPathList, CreateCareerPath } from "@/builders/types/career-path";

import { id } from "./id";

type Params = {
  page?: number;
  department?: number;
};

const get = function (params: Params = {}) {
  return api
    .get<CareerPathList>("career-paths", { params })
    .then(({ data }) => data);
};

const post = function (data: CreateCareerPath) {
  return api.post("career-paths", data).then(({ data }) => data);
};

export const career_path = {
  get,
  post,
  id,
};
